import { checkAuthentication } from './middleware';
export const clientRoutes = [
    {
        path: '/clients',
        name: 'ClientList',
        component:  () => import(/* webpackChunkName: "author-route" */ '../views/clients/ClientList.vue'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/clients/create',
        name: 'CreateClient',
        component: () => import(/* webpackChunkName: "author-route" */ '../views/clients/CreateClient'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/clients/:id/:tab?',
        name: 'ViewClient',
        component: () => import(/* webpackChunkName: "author-route" */ '../views/clients/ViewClient.vue'),
        props: true,
        beforeEnter: checkAuthentication
    },
]